import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { downloadFile } from "../utils/downloadFile";
import { getUserDetails } from "../utils/userDetailsUtils";

const downloadTestCaseResult = async (id, downloadType) => {
  const user = getUserDetails();

  const downloadUrl = `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=downloadTestCaseResults&companyid=${user.companyid}&caseresultid=${id}&type=${downloadType}`;

  await downloadFile(downloadUrl, { filename: `test_case_results_${id}` });
};

const useDownloadTestCaseQuery = (id, downloadType) => {
  return useQuery({
    queryKey: ["downloadTestCaseResult", id, downloadType],
    queryFn: () => downloadTestCaseResult(id, downloadType),
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useDownloadTestCaseQuery;
